import { useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom';
import { get_oli_user_call_details, oli_new_call_transcription } from "../services/apiService";
import { v4 as uuidv4 } from 'uuid';
import LogoutButton from '../components/LogoutButton';
import xoroLogo from "../assects/img/X_logo.png";



function MauiPrePostCall() {
  const [customersData, setCustomersData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [showProof, setShowProof] = useState<boolean>(false);
  const [selectedProof, setSelectedProof] = useState<string[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get('id') || 'No ID';
  const project_name = localStorage.getItem('oli_product') || 'Oli Product';
  const username = localStorage.getItem('userName') || 'User';
  const [showModal, setShowModal] = useState(false);
  const [current_user_chat_code, setCurrent_user_chat_code] = useState("");
  const [vpsOptions, setVpsOptions] = useState<any[]>([]);
  const [expandedCards, setExpandedCards] = useState<Record<string, boolean>>({});
  const [showInterestDetails, setShowInterestDetails] = useState<string | null>(null);
  const [showInterestModal, setShowInterestModal] = useState<string | null>(null);
  const [call_level_details, setCall_level_details] = useState([])

  const [vpsCategories, setVpsCategories] = useState<Record<string, string>>({});
  const project_id = searchParams.get("id") || "";
  const [newData, setNewData] = useState({
    additional_info: "",
    file: null as File | null,
    salesPerson: "",
    prospect: ""
  });

  const itemsPerPage = 10;

  async function getAll() {
    setLoading(true);
    const response = await get_oli_user_call_details(id, localStorage.getItem('oli_product_id') || '');
    if (response.status != "No user call details found") {
      setCustomersData(response.groups);
      setVpsOptions(response.vps || []);
      setCall_level_details(response.call_level_details)
    }
    setLoading(false);
  }

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setNewData({ ...newData, [name]: value });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setNewData({ ...newData, file });
  };

  const filteredCustomers = customersData.length !== 0 ? customersData.filter(
    (customer: any) =>
      new Date(customer.created_at).toLocaleString("en-IN", {
        dateStyle: "medium",
        timeStyle: "short",
      }).toLowerCase().trim().includes(searchTerm.toLowerCase())
  ) : [];

  const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
  const paginatedCustomers = filteredCustomers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleFormSubmit = async () => {
    setLoading(true)
    if (!newData.file || !newData.additional_info) {
      alert("Please fill all fields and upload a file.");
      setLoading(false)
      return;
    }

    const missingVp = (vpsOptions || []).some((vp: any) => !vpsCategories[vp.value_proposition]);
    if (vpsOptions.length > 0 && missingVp) {
      alert("Please select a category for each Value Proposition.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", newData.file);
    formData.append("salesPerson", newData.salesPerson);
    formData.append("prospect", newData.prospect);
    formData.append("user_chat_id", current_user_chat_code)
    formData.append("additional_info", newData.additional_info);
    formData.append("project_id", localStorage.getItem('oli_product_id') || '');
    formData.append("user_id", id);
    formData.append("vps", JSON.stringify(vpsCategories));

    try {
      await oli_new_call_transcription(formData);
      setShowModal(false);
      setNewData({ file: null, salesPerson: "", prospect: "", additional_info: "" });
      await getAll();
      alert("Upload sucessful");
    } catch (error) {
      console.error("Upload failed", error);
      alert("Upload failed.");
    }
    finally {
      setLoading(false)
      window.location.reload();
    }
  };

  useEffect(() => {
    getAll();
    const CC = uuidv4()
    setCurrent_user_chat_code(CC);
  }, []);

  const formatDT = (iso?: string) =>
    iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "";

  const statusPill = (s?: string) => {
    const v = (s || "").toLowerCase();
    if (v === "matched") return "bg-emerald-50 text-emerald-700 border-emerald-300";
    if (v === "almost") return "bg-amber-50 text-amber-700 border-amber-300";
    return "bg-rose-50 text-rose-700 border-rose-300";
  };

  const groups: any[][] = customersData || [];

  const filteredGroups = groups.filter(g => {
    const t = g?.[0]?.created_at;
    return formatDT(t).toLowerCase().includes(searchTerm.toLowerCase());
  });

  const paginatedGroups = filteredGroups.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const CATEGORY_OPTIONS = ["Cannot live without it", "Nice to have", "Not my problem"];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Brand & Title */}
            <div className="flex items-center space-x-4">
              <div className="flex-shrink-0">
                <div className="p-2.5 bg-white rounded-xl shadow-lg border border-gray-200/50">
                  <img
                    src={xoroLogo}
                    alt="Avironix Logo"
                    className="w-6 h-6 object-cover rounded-full"
                  />
                </div>
              </div>
              <div>
                <h1 className="text-xl font-semibold text-gray-900">OLI </h1>
                <p className="text-sm text-gray-500">Powered by XORO Story</p>
              </div>
            </div>

            {/* User Info & Actions */}
            <div className="flex items-center space-x-4">
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">
                  {localStorage.getItem('oli_username')}
                </p>
                <p className="text-xs text-gray-500">Administrator</p>
              </div>
              <LogoutButton />
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header with Actions */}
        <div className="mb-8">
          <div className="sm:flex sm:items-center sm:justify-between">
            <div>

              <div className="mt-2 flex items-center space-x-4">
                <div className="flex items-center space-x-2">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-2xl font-medium text-gray-900"> {username}</p>
                    <p className="text-xs text-gray-500">Project: {project_name}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 sm:mt-0 flex space-x-3">
              <button
                onClick={() => { window.history.back(); }}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Customer Info
              </button>
              <button
                onClick={() => setShowModal(true)}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                New Transaction
              </button>
            </div>
          </div>

          {/* Search Bar */}
          <div className="mt-6">
            <div className="max-w-md">
              <label htmlFor="search" className="sr-only">Search by meeting date & time</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <input
                  type="text"
                  id="search"
                  placeholder="Search by meeting date & time..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Data Table Card */}
        {/* Expandable Cards Layout */}
        <div className="space-y-4">
          {paginatedGroups.length ? (
            paginatedGroups.map((group, gIdx) => {
              const first = group[0] || {};
              const product = first.product || project_name;
              const createdAt = first.created_at;
              const cardId = `card-${gIdx}-${currentPage}`;

              const toggleCard = (cardId: string) => {
                setExpandedCards(prev => ({
                  ...prev,
                  [cardId]: !prev[cardId]
                }));
              };

              return (
                <div key={cardId} className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow">
                  {/* Collapsed Header - Always Visible */}
                  {/* Collapsed Header - Always Visible */}
                  <div className="p-4">
                    <div className="flex items-start justify-between">
                      {/* Left: Enhanced Info Section */}
                      <div className="flex items-start space-x-4 flex-1">
                        {/* Serial Number Badge */}
                        <div className="flex-shrink-0">
                          <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 text-white font-bold text-sm shadow-sm">
                            {(gIdx + 1) + (currentPage - 1) * itemsPerPage}
                          </span>
                        </div>

                        {/* Main Content */}
                        <div className="flex-1 min-w-0">
                          {/* Product & Status Row */}
                          <div className="flex items-center space-x-3 mb-2">
                            <div className="flex items-center space-x-2">
                              <div className="w-2.5 h-2.5 bg-blue-500 rounded-full animate-pulse"></div>
                              <h3 className="text-base font-semibold text-gray-900 truncate">{product}</h3>
                            </div>
                            <span className="px-2.5 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-medium flex-shrink-0">
                              {first.icp_status || call_level_details
                                .filter((l: any) => group[0].call_count === l.call_count)
                                .map((l: any) => l.icp_status)
                                .join(", ") 
                              || "Pending"}
                            </span>
                          </div>

                          {/* Meta Info Row */}
                          <div className="flex items-center space-x-4 text-xs text-gray-500">
                            <div className="flex items-center space-x-1">
                              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                              <span>{formatDT(createdAt)}</span>
                            </div>
                            <div className="flex items-center space-x-1">
                              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                              </svg>
                              <span>{group.length} Value Props</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right: Status Pills & Actions */}
                      <div className="flex items-start space-x-3 flex-shrink-0">
                        {/* Status Pills Column */}
                        <div className="text-right space-y-1.5">
                          <div className="flex justify-end space-x-1 flex-wrap">
                            <span className="px-3 py-1.5 bg-blue-50 text-blue-700 rounded text-xs font-medium whitespace-nowrap">
                              Stage - {call_level_details
                                .filter((l: any) => group[0].call_count === l.call_count)
                                .map((l: any) => l.fit_compass.stage)
                                .join(", ") || "No data"
                              }
                            </span>
                            <span className="px-3 py-1.5 bg-green-50 text-green-700 rounded text-xs font-medium whitespace-nowrap">
                              Confidence - {call_level_details
                                .filter((l: any) => group[0].call_count === l.call_count)
                                .map((l: any) => l.fit_compass.confidence)
                                .join(", ") || "No data"
                              }
                            </span>
                            <button
                              onClick={() => setShowInterestModal(cardId)}
                              className="px-2 py-0.5 bg-purple-50 text-purple-700 rounded text-xs font-medium hover:bg-purple-100 transition-colors whitespace-nowrap"
                            >
                              Interest Type - {call_level_details
                                .filter((l: any) => group[0].call_count === l.call_count)
                                .map((l: any) => (l.signal_classification.polite_interest.count === 0 && l.signal_classification.urgent_interest.count === 0) ? "No data" : (l.signal_classification.polite_interest.count > l.signal_classification.urgent_interest.count) ? "Polite" : "Urgent")
                                .join(", ") || "No data"
                              } ↗
                            </button>
                          </div>
                        </div>

                        {/* Expand/Collapse Button */}
                        <button
                          onClick={() => toggleCard(cardId)}
                          className="inline-flex items-center px-3 py-2 text-xs font-medium text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg border border-blue-200 transition-all duration-200 hover:shadow-sm"
                        >
                          {expandedCards[cardId] ? (
                            <>
                              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                              </svg>
                              Less
                            </>
                          ) : (
                            <>
                              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                              </svg>
                              More
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Interest Analysis Modal */}
                  {showInterestModal === cardId && (
                    <div className="fixed inset-0 z-50 overflow-y-auto">
                      <div className="flex min-h-screen items-center justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                        {/* Background overlay */}
                        <div
                          className="fixed inset-0 bg-gray-900 bg-opacity-50 transition-opacity"
                          onClick={() => setShowInterestModal(null)}
                        />

                        {/* Modal panel */}
                        <div className="relative inline-block align-middle bg-white rounded-xl px-6 pt-6 pb-6 text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                          {/* Header */}
                          <div className="flex items-start justify-between mb-6">
                            <div className="flex items-center space-x-3">
                              <div className="flex-shrink-0">
                                <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                                  <svg className="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                  </svg>
                                </div>
                              </div>
                              <div>
                                <h3 className="text-lg font-semibold text-gray-900">Oli Analysis</h3>
                                <p className="text-sm text-gray-500">Detailed conversation insights</p>
                              </div>
                            </div>
                            <button
                              onClick={() => setShowInterestModal(null)}
                              className="rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-1 transition-colors"
                            >
                              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>

                          {/* Interest Type Badge */}
                          <div className="mb-6">
                            <div className="inline-flex items-center px-3 py-1.5 bg-purple-50 text-purple-700 rounded-lg text-sm font-medium">
                              <div className="w-2 h-2 bg-purple-500 rounded-full mr-2"></div>
                              Interest Type: {call_level_details
                                .filter((l: any) => group[0].call_count === l.call_count)
                                .map((l: any) => (l.signal_classification.polite_interest.count === 0 && l.signal_classification.urgent_interest.count === 0) ? "No data" : (l.signal_classification.polite_interest.count > l.signal_classification.urgent_interest.count) ? "Polite" : "Urgent")
                                .join(", ") || "No data"
                              }
                            </div>
                          </div>

                          {/* Content */}
                          <div className="space-y-5">
                            <div className="bg-gray-50 rounded-lg p-4">
                              <div className="flex items-start space-x-3">
                                <div className="flex-shrink-0">
                                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                                    <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                  </div>
                                </div>
                                <div className="flex-1">
                                  <h4 className="text-sm font-medium text-gray-900 mb-1">Proof for Interest</h4>
                                  <p className="text-sm text-gray-600 leading-relaxed">{call_level_details
                                .filter((l: any) => group[0].call_count === l.call_count)
                                .flatMap((l: any) => {
                                  if(typeof l.signal_classification.polite_interest.proof === "string"){
                                    return [l.signal_classification.polite_interest.proof]
                                  }
                                  else{
                                    return l.signal_classification.polite_interest.proof
                                  }
                                }).map((l:any,index:number) => <div><p>{(index+1)+ "." +l}</p></div>)
                                || "No data"
                              }</p>
                                </div>
                              </div>
                            </div>

                            <div className="grid grid-cols-1 gap-4">
                              <div className="border border-gray-200 rounded-lg p-4">
                                <h4 className="text-sm font-medium text-gray-900 mb-2 flex items-center">
                                  <svg className="w-4 h-4 text-blue-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                                  </svg>
                                  Budget mentions
                                </h4>
                                <p className="text-sm text-gray-600">{call_level_details
                                .filter((l: any) => group[0].call_count === l.call_count)
                                .flatMap((l: any) => {
                                  if(typeof l.signal_classification.budget_mentions.proof === "string"){
                                    return [l.signal_classification.budget_mentions.proof]
                                  }
                                  else{
                                    return l.signal_classification.budget_mentions.proof
                                  }
                                }).map((l:any,index:number) => <div><p>{(index+1)+ "." +l}</p></div>)
                                || "No data"
                              }</p>
                              </div>

                              <div className="border border-gray-200 rounded-lg p-4">
                                <h4 className="text-sm font-medium text-gray-900 mb-2 flex items-center">
                                  <svg className="w-4 h-4 text-orange-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                  </svg>
                                  Timeline mentions
                                </h4>
                                <p className="text-sm text-gray-600">{call_level_details
                                .filter((l: any) => group[0].call_count === l.call_count)
                                .flatMap((l: any) => {
                                  if(typeof l.signal_classification.timeline_mentions.proof === "string"){
                                    return [l.signal_classification.timeline_mentions.proof]
                                  }
                                  else{
                                    return l.signal_classification.timeline_mentions.proof
                                  }
                                }).map((l:any,index:number) => <div><p>{(index+1)+ "." +l}</p></div>)
                                || "No data"
                              }</p>
                              </div>

                              <div className="border border-gray-200 rounded-lg p-4">
                                <h4 className="text-sm font-medium text-gray-900 mb-2 flex items-center">
                                  <svg className="w-4 h-4 text-red-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.502 0L3.311 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                  </svg>
                                  Adoption blockers
                                </h4>
                                <p className="text-sm text-gray-600">{call_level_details
                                .filter((l: any) => group[0].call_count === l.call_count)
                                .flatMap((l: any) => {
                                  if(typeof l.signal_classification.adoption_blockers.proof === "string"){
                                    return [l.signal_classification.adoption_blockers.proof]
                                  }
                                  else{
                                    return l.signal_classification.adoption_blockers.proof
                                  }
                                }).map((l:any,index:number) => <div><p>{(index+1)+ "." +l}</p></div>)
                                || "No data"
                              }</p>
                              </div>

                              <div className="border border-gray-200 rounded-lg p-4">
                                <h4 className="text-sm font-medium text-gray-900 mb-2 flex items-center">
                                  <svg className="w-4 h-4 text-indigo-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                  </svg>
                                  Benchmark Comparison
                                </h4>
                                <p className="text-sm text-gray-600">{call_level_details
                                .filter((l: any) => group[0].call_count === l.call_count)
                                .map((l: any) => l.benchmark_comparison)
                                .join(", ") 
                              || "Pending"}</p>
                              </div>

                              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                                <h4 className="text-sm font-medium text-blue-900 mb-2 flex items-center">
                                  <svg className="w-4 h-4 text-blue-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                  </svg>
                                  Recommended Action
                                </h4>
                                <p className="text-sm text-blue-800 font-medium">Schedule technical deep-dive session</p>
                              </div>
                            </div>
                          </div>

                          {/* Footer */}
                          <div className="mt-6 flex justify-end">
                            <button
                              onClick={() => setShowInterestModal(null)}
                              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-colors"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Expanded Content - Conditionally Visible */}
                  {expandedCards[cardId] && (
                    <div className="border-t border-gray-100 bg-gray-50">
                      <div className="p-4 space-y-3">
                        {group.map((row: any, rIdx: number) => (
                          <div key={rIdx} className="bg-white rounded-lg p-3 border border-gray-200">
                            <div className="flex items-start justify-between">
                              <div className="flex-1">
                                {/* VP Header */}
                                <div className="flex items-center space-x-2 mb-2">
                                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
                                    VP {rIdx + 1}
                                  </span>
                                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${statusPill(row.value_proposition_status)}`}>
                                    {row.value_proposition_status || "-"}
                                  </span>
                                </div>

                                {/* VP Content */}
                                <p className="text-sm text-gray-900 mb-2 leading-relaxed">
                                  {row.value_proposition || "-"}
                                </p>

                                {/* Rankings */}
                                {/* Rankings */}
                                <div className="flex items-center space-x-4 text-xs text-gray-600">
                                  <span>
                                    <span className="font-medium text-gray-700">Expected:</span> {row.expected_category || "-"}
                                  </span>
                                  <span className="text-gray-400">→</span>
                                  <span>
                                    <span className="font-medium text-gray-700">Actual:</span>
                                    <button
                                      onClick={() => {
                                        setShowProof(true);
                                        const proof = row.proof ? row.proof : "No Proof Available";
                                        setSelectedProof([proof, row.actual_category, row.value_proposition, row.expected_category]); // ADD row.expected_category HERE
                                      }}
                                      className="ml-1 text-blue-600 hover:text-blue-800 underline font-medium"
                                    >
                                      {row.actual_category || "-"}
                                    </button>
                                  </span>
                                </div>
                              </div>

                              {/* View Proof Button */}
                              <button
                                onClick={() => {
                                  setShowProof(true);
                                  const proof = row.proof ? row.proof : "No Proof Available";
                                  setSelectedProof([proof, row.actual_category, row.value_proposition, row.expected_category]); // ADD row.expected_category HERE
                                }}
                                className="ml-3 inline-flex items-center px-2 py-1 text-xs font-medium text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded border border-blue-200 transition-colors"
                              >
                                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Proof
                              </button>
                            </div>
                          </div>
                        ))}

                        {/* Mentioned VPs Section */}
                        {group[0]?.mentioned_vps && (
                          <div className="mt-3 bg-indigo-50 rounded-lg p-3 border border-indigo-200">
                            <h4 className="text-xs font-medium text-indigo-900 mb-2 flex items-center">
                              <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                              </svg>
                              Mentioned Value Propositions
                            </h4>
                            <div className="text-xs text-indigo-800 leading-relaxed max-h-24 overflow-y-auto">
                              {group[0].mentioned_vps.split('\n').map((line: string, i: number) => (
                                <p key={i} className="mb-1">
                                  {line.trim() === "-" ? "No specific mentions" : line}
                                </p>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            /* Empty State */
            <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
              <div className="flex flex-col items-center">
                <svg className="w-12 h-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <h3 className="text-sm font-medium text-gray-900">No data available</h3>
                <p className="text-sm text-gray-500 mt-1">Start by uploading your first transaction.</p>
              </div>
            </div>
          )}
        </div>
        {/* Pagination */}
        {paginatedGroups.length > 0 && (
          <div className="mt-6 flex items-center justify-between">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
              className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Previous
            </button>

            <span className="text-sm text-gray-700">
              Page <span className="font-medium text-gray-900">{currentPage}</span> of{" "}
              <span className="font-medium text-gray-900">{totalPages}</span>
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
              className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              Next
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        )}
      </main>
      {/* Upload Modal */}
{showModal && (
  <div className="fixed inset-0 z-50 overflow-y-auto">
    <div className="flex min-h-screen items-center justify-center px-4 py-6 text-center">
      {/* Background overlay */}
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        onClick={() => setShowModal(false)}
      />

      {/* Modal panel */}
      <div className="relative inline-block align-middle bg-white rounded-lg px-6 py-5 text-left overflow-hidden shadow-xl transform transition-all sm:max-w-3xl sm:w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-5">
          <div>
            <h3 className="text-lg font-medium text-gray-900">Upload New Transaction</h3>
            <p className="text-sm text-gray-500">Attach recording and map value propositions</p>
          </div>
          <button
            onClick={() => setShowModal(false)}
            className="text-gray-400 hover:text-gray-600 p-1"
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-5">
          {/* File Upload */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Upload File</label>
            <div className="flex justify-center px-6 py-4 border-2 border-gray-300 border-dashed rounded-md hover:border-gray-400 transition-colors">
              <div className="text-center">
                <svg className="mx-auto h-8 w-8 text-gray-400 mb-2" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                  <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <div className="text-sm text-gray-600">
                  <label className="cursor-pointer font-medium text-blue-600 hover:text-blue-500">
                    <span>Upload a file</span>
                    <input type="file" onChange={handleFileChange} className="sr-only" />
                  </label>
                  <span> or drag and drop</span>
                </div>
                <p className="text-xs text-gray-500">DOCX, PDF up to 10MB</p>
                {newData.file && (
                  <p className="text-xs text-green-600 mt-1">Selected: {(newData.file as any).name}</p>
                )}
              </div>
            </div>
          </div>

          {/* Form Fields */}
          <div className="grid grid-cols-2 gap-4">
            {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Sales Person</label>
              <input
                type="text"
                name="salesPerson"
                value={newData.salesPerson}
                onChange={handleFormChange}
                className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                placeholder="Enter sales person name"
              />
            </div> */}
            {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Prospect (Optional)</label>
              <input
                type="text"
                name="prospect"
                value={newData.prospect}
                onChange={handleFormChange}
                className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                placeholder="Enter prospect name"
              />
            </div> */}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Additional Information</label>
            <textarea
              name="additional_info"
              rows={3}
              value={newData.additional_info}
              onChange={handleFormChange}
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
              placeholder="Enter any additional context or notes..."
            />
          </div>

          {/* Value Propositions */}
          {vpsOptions.length > 0 && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Value Propositions & Categories</label>
              <div className="space-y-3">
                {vpsOptions.map((vp: any, index: number) => (
                  <div key={vp.id} className="bg-gray-50 rounded-md p-3">
                    <div className="mb-2">
                      <label className="block text-xs font-medium text-gray-600 mb-1">Value Proposition {index + 1}</label>
                      <div className="text-sm text-gray-900 bg-white rounded px-3 py-2 border border-gray-200">
                        {vp.value_proposition || ""}
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Select Category</label>
                      <select
                        value={vpsCategories[vp.value_proposition] || ""}
                        onChange={(e) => setVpsCategories((prev) => ({ ...prev, [vp.value_proposition]: e.target.value }))}
                        className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                      >
                        <option value="">Select a Category</option>
                        {CATEGORY_OPTIONS.map((c) => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="mt-5 pt-4 border-t border-gray-200 flex justify-end space-x-3">
          <button
            onClick={() => setShowModal(false)}
            className="px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleFormSubmit}
            disabled={loading}
            className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? 'Uploading...' : 'Submit Transaction'}
          </button>
        </div>
      </div>
    </div>
  </div>
)}


    
      {/* Proof Modal */}
      {/* Proof Modal */}
      {showProof && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-900 bg-opacity-50 transition-opacity"
              onClick={() => setShowProof(false)}
            />
            <div className="relative inline-block align-middle bg-white rounded-xl px-6 pt-6 pb-6 text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
              {/* Header */}
              <div className="flex items-start justify-between mb-6">
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Value Proposition Details</h3>
                    <p className="text-sm text-gray-500">Category assessment and evidence</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowProof(false)}
                  className="rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-1 transition-colors"
                >
                  <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* VP Category Badge */}
              <div className="mb-6">
                <div className="inline-flex items-center px-3 py-1.5 bg-blue-50 text-blue-700 rounded-lg text-sm font-medium">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                  Category: {selectedProof[1] || "Not categorized"}
                </div>
              </div>

              {/* Content */}
              <div className="space-y-5">
                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <div className="flex-shrink-0">
                      <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                        <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                        </svg>
                      </div>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-sm font-medium text-gray-900 mb-1">Value Proposition</h4>
                      <p className="text-sm text-gray-600 leading-relaxed">{selectedProof[2]}</p>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-4">
                  <div className="border border-gray-200 rounded-lg p-4">
                    <h4 className="text-sm font-medium text-blue-600 mb-2 flex items-center">
                      <svg className="w-4 h-4 text-blue-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                      Expected Response:&nbsp;
                        <p className="text-sm text-gray-600">{selectedProof[3] || "-"}</p>
                    </h4>
                  
                  </div>

                  <div className="border border-gray-200 rounded-lg p-4">
                    <h4 className="text-sm font-medium text-blue-600 mb-2 flex items-center">
                      <svg className="w-4 h-4 text-blue-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      Actual Response:&nbsp;
                       <p className="text-sm text-gray-600">{selectedProof[1] || "Not categorized"}</p>
                    </h4>
                  </div>

                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <h4 className="text-sm font-medium text-blue-900 mb-2 flex items-center">
                      <svg className="w-4 h-4 text-blue-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      Supporting Evidence
                    </h4>
                    <div className="max-h-32 overflow-y-auto">
                      <p className="text-sm text-blue-800">{selectedProof[0] || "No supporting evidence available"}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="mt-6 flex justify-end">
                <button
                  onClick={() => setShowProof(false)}
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Loading Overlay */}
      {loading && (
        <div className="fixed inset-0 z-50 bg-gray-900 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 flex items-center space-x-3">
            <svg className="animate-spin h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>
            <span className="text-gray-700 font-medium">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default MauiPrePostCall;